/*global jQuery */
//
// Description: lazyload image
// Dependencies: jquery.scrollcontrol.js
// Author: Kim Christiansen
//
( function ($, window) {
  'use strict';

  var $window,
      $document,
      $scope,
      defaultStyleClass = 'LazyLoadImage-loadedImage',
      setup = function () {

        $scope.on('scrollcontrol/isViewed', function (e) {
          // console.log('lazyloadimage: scrollcontrol/isViewed');
          loadImage($(this));
        });

      },
      loadImage = function($image) {
        var href = $image.data('lazyloadimage-src') || $image.attr('href');

        if( href ) {
          var styleClass = $image.data('lazyloadimage-styleclass') || defaultStyleClass;
          // console.log('load image: ' + href);

          var largeImage = new Image();
          largeImage.src = href;
          largeImage.className = styleClass + ' is-revealing js-lazyloadimge-large';
          if (largeImage.complete) {
            addImage($image, largeImage);
          } else {
            largeImage.onload = function(){addImage($image, largeImage);};
          }
        } else {
          console.warn('no large image link in LazyLoadImage');
        }
      },
      addImage = function($image, largeImage) {
        // console.log('addImage');
        // console.log($image);

        $image.append(largeImage);

        var tagName = $image.prop('tagName');

        if( tagName === 'A'){
          $image.on('click', function(e){ e.preventDefault();});
        }

        $(largeImage).on('animationend', function(e){
          // console.log('animation end');
          $image.removeClass('is-notReplaced');
          $(this).removeClass('is-revealing');
          $image.find('.js-lazyloadimage-small').remove();
        });

        $image.triggerHandler('lazyloadimage/imageLoaded');

      },
      init = function () {
        $window = $(window);
        $document = $(document);

        $scope = $('.js-lazyloadimage');
        if( $scope.length ) {
          setup();
        }

      };

  init();
}(jQuery, window));
